import { HpLoginSuccessPayload } from '@avantia/azure-ad-auth';
import { ensureDefined } from '@avantia/client-and-server-utilities';
import { applyChanges } from '../engineClient/reducers/reducerLibrary';
import { ReducerProcessor } from '../engineClient/reducers/reducerProcessor';
import { HpAction } from '../engineClient/types';
import { HpClaimsActionTypes } from '../types/actionTypes';
import { HpUserState } from '../types/stateTypes';
import { getInitialState } from './initialState';

const processor = new ReducerProcessor<HpUserState, HpClaimsActionTypes>('User');

export function createEmptyUserState(): HpUserState {
  const user: HpUserState = { name: '', email: '', sessionExpired: false };
  return user;
}

export function userReducer(state: HpUserState = getInitialState().user, action: HpAction<unknown>): HpUserState {
  return processor.process(state, action);
}

processor.add<HpAction<HpLoginSuccessPayload>>('RECEIVE_AUTHENTICATED_USER', (state, action) => {
  const { payload } = action;
  const { username: email, name } = ensureDefined(payload, 'payload');
  return applyChanges(state, { email, name, sessionExpired: false });
});

processor.add('CLAIMS_SESSION_EXPIRED', (state) => {
  return applyChanges(state, { sessionExpired: true });
});
